import { Transform } from "../../../../geometry/transformation";
import { sharedPointMapperRef, sharedEditorCanvas, sharedRubberCanvas, DrawOptions, sharedEditedHotspot } from "../../interface/pointMappings";
//import { recalculateShape } from "../../util/shapeEdit";
//todo: check and remove if not needed...
import { hitStrokeCorrection, strokeCorrection } from "../../util/strokeCorrection";
import { RubberDataBase, registerInteractionHandlers, ShapeInteractionHandlers } from "../interactionManager";
import { isSamePosition } from "../../../../geometry/geometry";
import * as Global from "../../../../global"
import { hitManager } from "../hitManager"


export interface PolygonRubberData extends RubberDataBase {
    points: Point2d[],
    hotspot?: Hotspot2d
}

export class Polygon {

    // draw functions
    static render(polygon: PolygonShape, isSelected: boolean, lineTypes: LineType[]) {
      const t = new Transform(polygon.transformation);

      const points = polygon.points.slice(0, -1).map(point => t.point2d(point));
      const drawOptions:DrawOptions = {
        color: polygon.stroke,
        width: polygon.strokeWidth,
        fillColor: polygon.fill,
        lineStyle: lineTypes.find(o => o.id === polygon.dashID)?.dash ?? [],
      }
      sharedEditorCanvas.current.drawPolygon(points, drawOptions);


      // we do not need the last point which is the duplicated version of the first one
      const hotspots: Hotspot2d[] = isSelected ? points.map((p, index) => { return { x: p.x, y: p.y, type: polygon.type, shapeId: polygon.id, innerId: index } }) : [];


      return hotspots;
    }

    static isHit(line: PolygonShape, p:Point2d) {
        let inside = false;
        const tr = new Transform(line.transformation);
        const points = line.points.slice(0, -1).map(p => tr.point2d(p));
        console.log(points, p)
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
            const xi = points[i].x, yi = points[i].y;
            const xj = points[j].x, yj = points[j].y;

            const intersect = ((yi > p.y) !== (yj > p.y)) &&
                            (p.x < (xj - xi) * (p.y - yi) / (yj - yi + 1e-10) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
        // for (let i = 1; i < line.points.length; ++i) {
        //     const tr = new Transform(line.transformation);
        //     const p1 = tr.point2d({ x: line.points[i - 1].x, y: line.points[i - 1].y});
        //     const x1 = p1.x;
        //     const y1 = p1.y;
        //     const p2 = tr.point2d({ x: line.points[i].x, y: line.points[i].y});
        //     const x2 = p2.x;
        //     const y2 = p2.y;
        //     const width = 15 / sharedPointMapperRef.current.zoom;

        //     const dx = x2 - x1;
        //     const dy = y2 - y1;
        //     const lenSq = dx * dx + dy * dy;

        //     const t = ((p.x - x1) * dx + (p.y - y1) * dy) / lenSq;
        //     if (t < 0 || t > 1) continue;

        //     const px = x1 + t * dx;
        //     const py = y1 + t * dy;
        //     const dist = Math.hypot(px - p.x, py - p.y);
        //     if (dist <= width / 2) {
        //         return true;
        //     }
        // }
        //return false;
    }

    static assembleShapeToInsert<L>(shape: L): L {
        return shape;
    }

}


const PolygonCreateHandlers: ShapeInteractionHandlers<PolygonRubberData, PolygonShape> = {
    rubberInputInit: (): PolygonRubberData => {
        const newRubberData: PolygonRubberData = {
            points: [],
            hotspot: undefined,
            finished: false,
        }

        return newRubberData;
    },
    rubberInputRenderer: (rubberPointData: PolygonRubberData, cursorPosition: Point2d) => {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        rubberPointData.points.forEach(p => {
            sharedRubberCanvas.current.drawCircle(p, 5, dotDrawOptions);
        });

        const lineDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_COLOR,
        }
        if (rubberPointData.points.length > 0) {
            const points = [...rubberPointData.points, cursorPosition];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
        }
    },
    rubberInputUpdater: (rubberPointData: PolygonRubberData, cursorPosition: Point2d) : PolygonRubberData => {
        if (rubberPointData.points.length > 0) {
            if (isSamePosition(rubberPointData.points[rubberPointData.points.length - 1], cursorPosition)) {
                rubberPointData.finished = true;
                return rubberPointData;
            }
        }

        return {...rubberPointData, points: [...rubberPointData.points, cursorPosition]};
    },
    callback: (shape: PolygonShape, rubberPointData: PolygonRubberData) : GeometricShape => {
        //todo: clean this up..
        return Polygon.assembleShapeToInsert<PolygonShape>({
            ...shape,
            id: 0,
            strokeWidth: strokeCorrection(shape.strokeWidth, sharedPointMapperRef.current.zoom),
            hitStrokeWidth: hitStrokeCorrection(shape.hitStrokeWidth, shape.hitStrokeWidth, sharedPointMapperRef.current.zoom),
            closed: true, //todo: does not seem to be necessary
            points: [ ...rubberPointData.points, rubberPointData.points[0] ],
        });
    },
}

const PolygonHotspotEditHandlers: ShapeInteractionHandlers<PolygonRubberData, PolygonShape> = {
    rubberInputInit: (shape: PolygonShape): PolygonRubberData => {
        let rubberData: PolygonRubberData = {
            points: [],
            hotspot: sharedEditedHotspot.current,
            finished: false
        };
        shape.points.forEach(p => {
            rubberData.points.push(p);
        })

        return rubberData;
    },
    rubberInputRenderer: (rubberPointData: PolygonRubberData, cursorPosition: Point2d) => {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        rubberPointData.points.forEach(p => {
            sharedRubberCanvas.current.drawCircle(p, 5, dotDrawOptions);
        });

        let lineDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_COLOR,
            lineStyle: Global.LINE_SOLID,
        }
        if (rubberPointData.points.length > 0) {
            //sharedRubberCanvas.current.drawPolyLine(rubberPointData.points, lineDrawOptions);
            if (!rubberPointData.hotspot) return;

            if (rubberPointData.hotspot.innerId > 0) {
                let points = [rubberPointData.points[rubberPointData.hotspot.innerId - 1], cursorPosition];
                sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            }
            else {
                let points = [rubberPointData.points[rubberPointData.points.length - 2], cursorPosition];
                sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            }
            lineDrawOptions.lineStyle = Global.LINE_DOTTED;
            let points = [rubberPointData.points[rubberPointData.hotspot.innerId], cursorPosition];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            if (rubberPointData.hotspot.innerId < rubberPointData.points.length - 1) {
                lineDrawOptions.lineStyle = Global.LINE_SOLID;
                points = [rubberPointData.points[rubberPointData.hotspot.innerId + 1], cursorPosition];
                sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            }
        }
    },
    rubberInputUpdater: (rubberPointData: PolygonRubberData, cursorPosition: Point2d) : PolygonRubberData => {
        if (!rubberPointData.hotspot) return rubberPointData;

        console.log("updating position");
        rubberPointData.points[rubberPointData.hotspot?.innerId] = cursorPosition;
        rubberPointData.points[rubberPointData.points.length - 1] = rubberPointData.points[0];
        rubberPointData.finished = true;

        return rubberPointData;
    },
    callback: (shape: PolygonShape, rubberPointData: PolygonRubberData) : GeometricShape => {
        const newShape = {
            ...shape,
            points: rubberPointData.points,
        }
        return newShape;
    },
}

hitManager.register("polygon", Polygon.isHit);
registerInteractionHandlers("polygon", "create", PolygonCreateHandlers);
registerInteractionHandlers("polygon", "edit", PolygonHotspotEditHandlers);